// original code from  ACEPayments/src/utils/cookieHelper.js                                                                                                                                      898/898               100%

import { CAMPAIGN_CODE_QUERY_PARAM } from './constants';

export default class CookieHelper {
  static getCookie(name: string) {
    if ((global as any).document) {
      const value = `; ${(global as any).document.cookie}`;
      let parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(';').shift();
    }
    return null;
  }

  static getClubCodeFromZipcodeCookie() {
    const zipcodeCookie = CookieHelper.getCookie('zipcode');
    let zipcodeResult = '';
    if (zipcodeCookie) {
      const zipcodeCookieArray = zipcodeCookie.split('|');
      zipcodeResult = zipcodeCookieArray[2] ? zipcodeCookieArray[2] : '';
    }
    return zipcodeResult.trim().padStart(3, '0');
  }

  static getZipcodeFromZipcodeCookie() {
    const zipcodeCookie = CookieHelper.getCookie('zipcode');

    if (zipcodeCookie) {
      const zipcodeCookieArray = zipcodeCookie.replace('"', '').split('|');
      let zipcodeResult: any = zipcodeCookieArray[0] ? zipcodeCookieArray[0] : null;
      return zipcodeResult;
    }

    return null;
  }

  static getCampaignCodeFromCookie() {
    const campaignCodeCookie = CookieHelper.getCookie(CAMPAIGN_CODE_QUERY_PARAM);
    return campaignCodeCookie ?? null;
  }

  static addCookie(cname: any, cvalue: any, domain: any, exdays: number, path = '/') {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=${path};domain=${domain}`;
  }

  static getStateFromZipcodeCookie() {
    const zipcodeCookie = CookieHelper.getCookie('ace-zipdata');
    if (zipcodeCookie) {
      const zipcodeCookieArray = zipcodeCookie.replace('"', '').split('|');
      let state = zipcodeCookieArray[0] ? zipcodeCookieArray[0] : '';
      return state;
    }

    return '';
  }
}
